
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveback-2023",
      function () {
        return require("private-next-pages/giveback-2023.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveback-2023"])
      });
    }
  